import { getHttpClient } from 'src/http-client';

export async function getClassificationDataService(args: {
  organizationName: string;
  projectId: string;
}) {

	try {
		const client = getHttpClient();
		const response = await client.get(`https://dev.azure.com/${args.organizationName}/${args.projectId}/_apis/wit/classificationnodes?$depth=2&api-version=6.0`);

		if (response.status == 200) {
			return response.data;
		}

		return null;
	} catch (err) {
		return null;
	}
}